// extracted by mini-css-extract-plugin
export default {"card-stack-form":"card-stack-form__haek"};